import _ from 'lodash';
import { SDLUtil, RequestUtil, StringUtil, DateUtil } from '@/utils';

const setRegionList = ({ commit }, data) => {
  commit('SET_REGION_LIST', data);
};

export default {
  async GET_REM_REGION_LIST(store) {
    const response = await RequestUtil.get(`${SDLUtil.API_URL}/rem/service/GetRegionList`);
    const regionList = response.data.data;
    setRegionList(store, regionList);
    return response;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/rem/region/regionActions.js